import React from 'react'
import NeuroScreenDashboard from '../../src/neuroscreen/pages/NeuroScreenDashboard'
import NeuroTestTable from '../../src/neuroscreen/table/neuroTestTable'
import Header from '../../src/components/Dashboard/Header'
import { Routes, Route, Link, useRoutes } from "react-router-dom";

const NeuroScreenLayout = () => {
    const neuroScreenRoutes = (
        <Routes>
            <Route index element={<NeuroScreenDashboard  />} />
            <Route path="TubeTest_Response/:sessionId" element={<NeuroTestTable />} />
            <Route path="FaceAware/:sessionId" element={<NeuroTestTable />} />
            {/* <Route index element={<TempwareDevice />} /> */}
        </Routes>
    );
    return (
        <div >
            <section>
                <div className="d-flex align-items-start gap-lg-5 gap-md-4 gap-4">
                    <Header />
                    {neuroScreenRoutes}
                </div>
            </section>
        </div>
    )
}

export default NeuroScreenLayout